<ng-template #defaultTemplate let-option>
  <img [src]="option.icon" *ngIf="option.icon" />
  {{ getLabel(option) }}
</ng-template>

<div class="input input-select" [style.margin-bottom]="messagePad" [style.width]="width">
  <div [ngClass]="{ 'p-field': true, left: labelPositionLeft }">
    <label [for]="name" [style.width]="labelWidth"
      >{{ label }}<app-label-icon *ngIf="labelIcon" [data]="labelIcon"
    /></label>
    <div [style.width]="inputWidth">
      <p-dropdown
        *ngIf="!readOnly"
        appReadOnly
        [ignoreReadOnly]="ignoreReadOnly"
        [inputId]="name"
        [attr.name]="name"
        [options]="options"
        #model="ngModel"
        [(ngModel)]="selectedItem"
        [required]="required"
        [placeholder]="placeholder"
        [optionLabel]="optionLabel"
        [class.has-errors]="displayErrors"
        (onChange)="onValueChange($event)"
        [disabled]="isDisabled"
        (onBlur)="onBlur($event)"
        (onFocus)="onFocusInput($event)"
        [attr.aria-invalid]="displayErrors"
        [attr.aria-describedby]="displayErrors ? name + '-error' : null"
        [scrollHeight]="scrollHeight"
        [tabindex]="tabindex"
      >
        <ng-template let-selectedItem pTemplate="selectedItem">
          <div class="item item-selected" *ngIf="selectedItem" aria-live="assertive">
            <ng-container
              [ngTemplateOutlet]="optionTemplate || defaultTemplate"
              [ngTemplateOutletContext]="{ $implicit: selectedItem, index: i }"
            >
            </ng-container>
          </div>
        </ng-template>
        <ng-template let-item pTemplate="item">
          <div class="item">
            <ng-container
              [ngTemplateOutlet]="optionTemplate || defaultTemplate"
              [ngTemplateOutletContext]="{ $implicit: item, index: i }"
            >
            </ng-container>
          </div>
        </ng-template>
      </p-dropdown>
      <span *ngIf="readOnly" class="readonly">{{ selectedItem.name }}</span>
      <div class="error-container" *ngIf="displayErrors" [attr.id]="name + '-error'" role="alert" aria-atomic="true">
        <span *ngFor="let error of errors" class="p-error">{{ error }}</span>
      </div>
    </div>
  </div>
</div>
